import { companyFormFieldsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const COMPANY_FORM_FIELD_DATA_ACTION_TYPE = createNamedActions('companyFormFieldData', {
  GET_FORM_FIELD_DATA: 'GET_FORM_FIELD_DATA',
  EDIT_FORM_FIELD_DATA: 'EDIT_FORM_FIELD_DATA',
  CREATE_TRUSTEE: 'CREATE_TRUSTEE',
  EDIT_TRUSTEE: 'EDIT_TRUSTEE',
  DELETE_TRUSTEE: 'DELETE_TRUSTEE',
});

export const getCompanyFormFieldsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await companyFormFieldsApi.getCompanyFormFields(params);

  return dispatch({
    type: COMPANY_FORM_FIELD_DATA_ACTION_TYPE.GET_FORM_FIELD_DATA,
    payload: { [params.companyId]: data },
  });
});

export const editCompanyFormFieldsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await companyFormFieldsApi.editCompanyFormFields(params);

  return dispatch({
    type: COMPANY_FORM_FIELD_DATA_ACTION_TYPE.EDIT_FORM_FIELD_DATA,
    payload: { companyId: params.companyId, ...data },
  });
});

export const createCompanyTrusteeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await companyFormFieldsApi.createCompanyTrustee(params);

  return dispatch({
    type: COMPANY_FORM_FIELD_DATA_ACTION_TYPE.CREATE_TRUSTEE,
    payload: { companyId: params.companyId, trustee: data },
  });
});

export const editCompanyTrusteeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await companyFormFieldsApi.editCompanyTrustee(params);

  return dispatch({
    type: COMPANY_FORM_FIELD_DATA_ACTION_TYPE.EDIT_TRUSTEE,
    payload: { companyId: params.companyId, trustee: data },
  });
});

export const deleteCompanyTrusteeAction = catchAsyncActionError(params => async dispatch => {
  await companyFormFieldsApi.deleteCompanyTrustee(params);

  return dispatch({
    type: COMPANY_FORM_FIELD_DATA_ACTION_TYPE.DELETE_TRUSTEE,
    payload: { companyId: params.companyId, trusteeId: params.trusteeId },
  });
});
